import { render, staticRenderFns } from "./CollegeSubscriptionPracticeTestsChild.vue?vue&type=template&id=630a118c"
import script from "./CollegeSubscriptionPracticeTestsChild.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptionPracticeTestsChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports